import { MediaFactory } from '../../commons';
export class SoftSkillFactory {
    static create(props = {}) {
        const defaultProps = {
            id: 1,
            name: 'Soft skill name',
            description: 'Soft skill description',
            icon: MediaFactory.create()
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=soft-skill.factory.js.map